<template>
  <div class="mine-comment">
    <div class="comment-title">
      <span @click="gotoTracelNotesDetail(item.dataId)">{{
        commentTitle
      }}</span>
    </div>
    <div class="comment-content">
      <p>{{ commentContent }}</p>
    </div>
    <div class="comment-footer">
      <div class="comment-date">发表于:{{ commentDate }}</div>
      <div class="comment-operate">
        <div class="comment-like">
          <span
            class="comment-like-icon iconfont"
            :class="commentIsLike ? 'iconyizan' : 'iconzan'"
            @click="toggleLike"
          ></span>
          <span
            class="comment-like-number"
            :class="commentIsLike ? 'like-number' : 'not-like-number'"
            >{{ commentLikeNumber }}</span
          >
        </div>
        <span
          class="comment-delete iconfont iconshanchu"
          @click="deleteComment(item)"
        ></span>
      </div>
    </div>
  </div>
</template>
<script>
import targetUrl from "@/assets/images/travel/new-target.png";
export default {
  props: {
    //当前评论对象
    item: {
      type: Object
    },
    //评论标题
    commentTitle: {
      type: String
    },
    //评论内容
    commentContent: {
      type: String
    },
    //评论日期
    commentDate: {
      type: String
    },
    //评论点赞数量
    commentLikeNumber: {
      type: Number,
      default: 0
    },
    //是否属于我的点赞
    commentIsLike: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleLike(item) {
      this.$emit("toggleLike", { item });
    },
    deleteComment(item) {
      this.$emit("deleteComment", { item });
    },
    gotoTracelNotesDetail(trvelNoteId) {
      let routeUrl = this.$router.resolve({
        path: `/detail/new${trvelNoteId}`
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style lang="less">
.mine-comment {
  .comment-title {
    display: flex;
    justify-content: flex-start;
    span {
      color: #57dec1;
      font-size: 20px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .comment-content {
    p {
      text-align-last: start;
      color: #555;
      font-size: 14px;
      line-height: 30px;
    }
  }
  .comment-footer {
    display: flex;
    justify-content: space-between; //横向两端对齐
    align-items: center; //纵向居中对齐
    .comment-date {
      font-size: 14px;
      color: #999999;
      line-height: 33px;
    }
    .comment-operate {
      display: flex;
      align-items: center;
      .comment-like {
        .comment-like-icon {
          cursor: pointer;
        }
        .comment-like-number {
          margin-left: 6px;
        }
        .iconyizan,
        .iconzan {
          color: #57dec1;
        }
        .like-number {
          color: #57dec1;
        }
        .not-like-number {
          color: #999;
        }
      }
      .comment-delete {
        cursor: pointer;
        margin-left: 20px;
      }
      .iconshanchu {
        color: #57dec1;
      }
    }
  }
}
</style>
